<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <!-- Botones de acceso rápido -->
            <v-container>
                <v-row dense>
                    <v-col cols="auto">
                        <v-btn color="#1e3f7a" dark @click="irAvanceHoras">
                            <v-icon left>mdi-clock-check-outline</v-icon>Avance de Horas
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="#27ae60" dark @click="$router.push({ name: 'HorasAvanceSector' })">
                            <v-icon left>mdi-account-group</v-icon>Avance de Horas por Sector
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>

            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Realización de las órdenes de trabajo correspondiente al área, destinadas a obras
                                    o a clientes finales, procurando optimizar los procesos y costos, manteniendo los
                                    más altos niveles de calidad y respetando los plazos de entrega.
                                </p>
                                <p>
                                    * Proveer mano de obra y soluciones a clientes internos como a brigadas, obras,
                                    SS.GG., depósito, etc. para realización de las diversas tareas que mejoren la
                                    funcionalidad y seguridad de las instalaciones.
                                </p>
                                <p>
                                    * Todas las actividades se deberán desarrollar respetando las normativas relativas a
                                    higiene y seguridad, y al cuidado del medio ambiente.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row dense>
                    <v-col v-for="(item, i) in listado" :key="i" cols="12" md="6" lg="4">
                        <v-card :color="colorCumplimiento(item.valoractual)">
                            <v-card-title>Objetivo: {{ item.codgral }}</v-card-title>

                            <v-card-text>
                                <div><strong>Descr.:</strong> {{ item.objetivo }}</div>
                                <div><strong>Tipo:</strong> {{ item.tipo }}</div>

                                <div>
                                    <strong>Meta:</strong>
                                    <pre class="meta">{{ item.meta }}</pre>
                                </div>

                                <div><strong>Indicador:</strong> {{ item.indicador }}</div>
                                <div><strong>Responsable:</strong> {{ item.responsable }}</div>
                                <div><strong>Cumplimiento:</strong> {{ item.cumplimiento }}%</div>
                                <div><strong>Valor Indic / Referencia:</strong> {{ item.valoractual }} / {{
                                    item.referencia }}</div>
                                <div><strong>Plan:</strong> {{ item.plan }}</div>
                                <div><strong>Observaciones:</strong> {{ item.observ }}</div>

                                <div>
                                    <strong>Fecha de Actualización:</strong>
                                    {{ item.fecha }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>
<style>
.meta {
    white-space: pre-wrap;
    /* ← Para permitir varias líneas */
    font-family: inherit;
}
</style>
<script>
import axios from "../../axios-auth.js";
import axiossistema from "@/axios-auth-sistemas";
import moment from "moment";
export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
        listado: [],
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
        this.cargarListado();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Fabricacion";
        }
    },
    methods: {
        irAvanceHoras() {
            try {
                axiossistema
                    .get("/Horas/getHorasPermisos?", {
                        params: {
                            usuario: this.$store.state.nombre,
                        },
                    })
                    .then(() => {
                        this.$router.push({ name: "HorasAvanceNuevo" });
                    })
                    .catch(() => {
                        this.$swal("", "No tiene permisos para ingresar", "warning");
                    });
            } catch (error) {
                this.$swal("", "No tiene permisos para ingresar", "warning");
            }
        },

        colorCumplimiento(item) {
            if (item != null && item != "") {
                if (item == "0") {
                    return "red";
                }
                if (item == "100") {
                    return "green";

                }
                if (item.replace(",", ".") > 0 && item.replace(",", ".") < 100) {
                    return "yellow";
                }
            }
        },

        cargarListado() {
            this.loadtable = true;
            const codgral = "";
            const periodo = "";
            const objetivo = "";
            const meta = "";
            const indicador = "";
            const responsable = "";
            const area = "Fabricación";
            const tipo = "";
            const asociado = "";

            let self = this;
            axios
                .get("/Indicadores/ListadoObjetivos?", {
                    params: {
                        codgral: codgral,
                        periodo: periodo,
                        objetivo: objetivo,
                        indicador: indicador,
                        responsable: responsable,
                        meta: meta,
                        asociado: asociado,
                        area: area,
                        tipo: tipo,

                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>